<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('company.plural').toUpperCase()}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <router-link
            tag="button"
            :to="'edit?id=' + $route.query.id"
            class="btn btn-info btn-sm mr-1"
          >
            <i class="uil uil-edit mr-1"></i>{{$t('common.edit')}} 
          </router-link>

          <b-dropdown class="d-inline-block"
            variant="soft-secondary"
            right
            size="sm">
            <template v-slot:button-content>
              <i class="uil uil-cog"></i>
            </template>
            <b-dropdown-item @click="onClickCompany"><i class="uil uil-link-alt mr-1"></i> Send Link to Company</b-dropdown-item>
          </b-dropdown>
          
        </div>
        
      </div>
    </fixed-header>
    <div class="text-center loaderko" v-if="loading">
      <div class="spinner-grow text-primary m-2 " role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="text-muted small">Loading</div>
    </div>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="row border-bottom mb-2">
              <div class="col-md-6 col-sm-6">
                <div class="media">
                  <img src="@assets/images/users/avatar-7.jpg" 
                    ref="imagePreview"
                    class="mr-3 avatar-lg rounded" alt="shreyu">
                  <div class="media-body">
                      <h5 class="mt-1 mb-0">{{model.name}}</h5>
                      <h6 class="font-weight-normal mt-1 mb-1">
                        {{model.email}}
                      </h6>
                      <p class="text-muted">{{model.city}}, {{model.country}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 text-right">
                <h6 class="mt-1 mb-0 font-size-15">{{$t('company.form.fees')}}</h6>
                <h6 class="text-muted font-weight-normal mt-1 mb-3">{{model.fixed && model.rate ? model.rate.$numberDecimal : '' |currency(currency_symbol, currency_symbol == '¥' ? 0 : 2)}}
                  {{!model.fixed && model.rate ? model.rate.$numberDecimal + '%' : ''}}
                </h6>
              </div>
            </div>
            
            <p v-html="model.remarks"></p>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <b-tabs>
          <b-tab title="Jobs" active>
            <DataTable
              :company_id="model._id"
              :type.sync="type"
              :noTitle="true"
            />
          </b-tab>
          <b-tab title="Contact Persons" lazy>
            <div class="row page-title align-items-center">
              <div class="col-md-3 col-xl-6">
                <button class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0" @click="openCreateModal">
                  <i class="uil-plus mr-1"></i> {{ $t('job.action.create_record') }}
                </button>
              </div>
            </div>
            <Table
              ref="contact_table"
              :useEdit="true"
              :params="params"
              :noTitle="true"
              :fields="fields"
              :action="action"
              @openFormBar="openFormBar"
              @radioClicked="radioClicked"
            />
          </b-tab>
        </b-tabs>
      </div>
      <CreateModal ref="createModal" @refreshData="refreshData" :company_id="model._id" />
    </div>
  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import DataTable from '@common/datatable2'
import Table from '@components/table'
import CreateModal from '@pages/company/createModal'

export default {
  mixins: [FormMixin],
  components:{
    FixedHeader,
    DataTable,
    Table,
    CreateModal
  },
  data(){
    return {
      model:{
        name: '',
      },
      params: {},
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      type: 'active',
      fields: [
        { 
          key: 'radio',
          label: 'Default'
        },
				{ label: this.$t('candidate.form.first_name.label'), key:"first_name", sortable: true},
				{ label: this.$t('candidate.form.last_name.label'), key:"last_name", sortable: true},
				{ label: this.$t('candidate.form.email.label'), key:"email", sortable: false},
				{ label: this.$t('candidate.form.gender.label'), key:"gender", sortable: false},
        {
          key:'actions',
          label:''
        }
      ],
      action: 'company/getContactPersons'
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  methods: {
    onView(){
      this.$router.push('/company')
    },
    ...mapActions('company', ['create', 'find', 'sendLink', 'setCPDefault']),
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onClickCompany(){
      this.$bvModal.msgBoxConfirm('Please confirm that you want to send link to the company(this will use company email and will be sending a temporary link for company view).', {
        titleHtml: '<i class="uil uil-exclamation-triangle text-warning"></i> Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitleHtml: '<i class="uil uil-message"></i> SEND LINK',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.sendLink({
            id:this.$route.query.id,
          }).then(res => {
            if(res.data.success){
              this.$bvToast.toast(`Successfully sent to the company!`, {
                title: 'Notification',
                variant:'success'
              })
            }
            this.toggleLoading()
          })
        }
      })
    },
    openCreateModal() {
      this.$refs.createModal.show()
    },
    refreshData(){
      this.$refs.contact_table.fetchData()
    },
    openFormBar(id, editMode = false) {
      if(editMode){
        this.$refs.createModal.show(id)
      }
    },
    radioClicked(id){
      this.setCPDefault({id})
      .then(()=> {
        this.refreshData()
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  beforeMount() {
    this.find({
      id:this.$route.query.id
    }).then(data => {
      this.model = data.data
      if(this.model.avatar_path != '')
      this.$refs['imagePreview'].src = this.model.avatar_path

      this.params = { id : this.model._id }
    })
    this.model._id = this.$route.query.id
  }
}
</script>

<style lang="scss">
.loaderko{
  position: absolute;
  height: 100%;
  z-index: 9;
  background: #ffffffc7;
  width: 100%;
  /* vertical-align: middle; */
  /* margin: auto; */
}
</style>